import React, { PureComponent } from 'react';
import styles from './index.css';
import { getClsData } from '../../../../../services/api';

class Zhiboshi extends PureComponent {
    timer = null; // 定时器
    state = {
        title: null, // 直播间标题
        id: null, // 当前的标题id
    };

    componentDidMount() {
        this.getNewTitle();
        this.timer = setInterval(this.getNewTitle, 30000);
    }
    componentWillUnmount() {
        clearInterval(this.timer);
        this.timer = null;
    }
    // 获取新的直播间标题
    getNewTitle = async () => {
        try {
            const data = await getClsData(Date.parse(new Date()));
            const infor = data.data && data.data.length > 0 ? data.data[0] : '';

            if (this.state.id !== infor.id) {
                let title = infor.brief;

                if (title.length > 26) {
                    title = `${title.substring(0, 26)}...`;
                }
                this.setState({
                    id: infor.id,
                    title,
                });
            }
        } catch (err) {
            console.error(err);
        }
    };
    render() {
        return (
            <div className={styles.zhiboshi}>
                <a className={styles.link} href="//finance.ifeng.com/studio" target="_blank" rel="noreferrer">
                    <span dangerouslySetInnerHTML={{ __html: this.state.title }} />
                </a>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Zhiboshi.propTypes = {};

/**
 * 定义组件默认属性
 * */
Zhiboshi.defaultProps = {};

export { Zhiboshi };
export default Zhiboshi;
